import StatusChip from "@entrilia/shared/components/StatusChip";
import type { ActivityDisplayStatus } from "./workflowDetailsHelpers";

interface Props {
  status: ActivityDisplayStatus;
}

const WorkflowActivityStatusTag = ({ status }: Props) => {
  switch (status) {
    case "NotStarted":
      return <StatusChip label="Not Started" withDot color={(t) => t.palette.text.secondary} />;
    case "Executing":
      return <StatusChip label="Executing" withDot color={(t) => t.palette.info.main} />;
    case "PendingApproval":
      return <StatusChip label="Pending Approval" withDot color={(t) => t.palette.warning.main} />;
    case "Pending":
      return <StatusChip label="Pending" withDot color={(t) => t.palette.warning.main} />;
    case "Completed":
      return <StatusChip label="Completed" withDot color={(t) => t.palette.success.main} />;
    case "Skipped":
      return <StatusChip label="Skipped" withDot color={(t) => t.palette.text.disabled} />;
    case "Cancelled":
      return <StatusChip label="Canceled" withDot color={(t) => t.palette.text.secondary} />;
  }
};

export default WorkflowActivityStatusTag;
